module.exports = __webpack_public_path__ + "assets/img/asticot.13d8efaa.png";